@use '~/theme/theme' as *;
@use '~/theme/typography';

.container {
  display: flex;
  gap: spacing(2);
  align-items: flex-start;
}

.labelContainer {
  flex-shrink: 0;
  flex-basis: 100px;
  display: flex;
  align-items: flex-end;
  height: 65px;
}

.label {
  height: 32px;
}

.icon {
  color: color(grey-800);
}

.input {
  min-width: 200px;
}

.deleteContainer {
  padding-top: 26px;
  height: 32px;
}
